import React from "react";
import AuthForm from "components/Forms/AuthForm";
import Header from "components/Header";

const IndexPage = () => {
  return (
    <section class="main  phone-number">
      <Header />
      <AuthForm />
    </section>
  );
};

export default IndexPage;
